<script setup lang="ts">
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
}
const { sale } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
</script>

<template>
    <UAlert
        v-if="sale.includesDepotService"
        :title="tt('sdp.depot.title')"
        :description="tt('sdp.depot.description')"
        color="neutral"
        variant="subtle"
    >
        <template #actions>
            <SdpDepotVisitBookingModalButton :sale="sale" size="sm" />
        </template>
    </UAlert>
</template>
